export class BaseUserBuilder {
    constructor(user) {
        /**
         * If existing user object needs to be changed.
         * The object can be based as part of the builder to copy the properties.
         */
        if (user && user.toJSON) {
            this.json = user.toJSON();
        }
        else {
            /**
             * If user already has the User information they can pass on the JSON to create the user object.
             */
            this.json = user || {};
        }
    }
    id(id, idHash) {
        this.json.id = id;
        this.json.idHash = idHash;
        return this;
    }
    authenticated(value) {
        this.json.authenticated = value;
        return this;
    }
    userType(value) {
        this.json.type = value;
        return this;
    }
    userOrg(value) {
        this.json.org = value;
        return this;
    }
    details(value) {
        this.json.details = value;
        return this;
    }
    context(value) {
        this.json.context = value;
        return this;
    }
    actAs(value) {
        this.json.as = value;
        return this;
    }
}
//# sourceMappingURL=UserBuilder.js.map